export default function roundOffMoney(amount) {
    return parseFloat((amount.toString().replace(/..$/,"00")));
}